import appointments from './appointments.js';
import auth from './auth.js';
import automations from './automations.js';
import chat from './chat.js';
import configs from './configs.js';
import contacts from './contacts.js';
import campaigns from './campaigns.js';
import global from './global.js';
import imports from './imports.js';
import payments from './payments.js';

export default {
    appointments,
    auth,
    automations,
    chat,
    configs,
    contacts,
    campaigns,
    global,
    imports,
    payments,
};
